<template>
  <div>
    <v-app>
      <v-snackbar class="pt-6 pr-6" style="z-index: 6 !important" transition="slide-x-reverse-transition"
        v-model="datasnackbar" timeout="-1" :value="true" color="#3B82F6" absolute outlined top right>
        <v-icon class="mr-2" color="#3B82F6">mdi-alert-outline</v-icon>
        {{ datamsg }}
        <v-icon @click="datasnackbar = false" class="float-right" color="#3B82F6">mdi-close-circle</v-icon>

      </v-snackbar>
      <v-container class="pa-0 pa-sm-3 pa-md-3">
        <div class="px-4 px-sm-4">
          <div class="dash-header mb-4 mt-16 mt-md-6">
            <div class="dash-header__titles">
              <div class="font-weight-bold headline dash-header__title">Dashboard</div>
              <div class="mt-1 dash-header__subtitle">
                Stats of current standing clients' revenues, trades, and
                status here.
              </div>
            </div>
            <v-menu ref="menu" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition"
              offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-text-field color="#3B82F6" class="rounded-lg dash-header__picker" outlined dense
                  hide-details v-model="date" label="Month" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs"
                  v-on="on"></v-text-field>
              </template>
              <v-date-picker color="#3B82F6" :max="latest" @change="monthChange()" v-model="date" type="month" no-title
                scrollable>
              </v-date-picker>
            </v-menu>
          </div>
          <div class="px-4 pt-2 mb-6">
            <v-row>
              <v-col cols="12" md="8">
                <div>
                  <v-progress-linear color="#3B82F6" v-if="revloader === 'l'" indeterminate></v-progress-linear>
                  <v-card class="px-4 py-2 mb-4" outlined>

                    <p class="font-weight-bold">Revenue stat</p>

                    <!-- <v-row class="mb-2">
                      <v-col cols="12" sm="6" class="pr-sm-1">
                        <v-card class="rounded-lg" outlined>
                          <v-list-item two-line>
                            <v-list-item-content>
                              <v-list-item-subtitle class="mb-2">Day average
                                <v-chip color="#3B82F6" class="white--text " small><b>{{ archiveData.Cost ?
                                  archiveData.Cost.tranding_days : 0 }}</b>&nbsp;vs&nbsp;<b>{{ archiveData.Cost
    ?
    archiveData.Revenue.Trading_days_count : 0 }}</b></v-chip>

                              </v-list-item-subtitle>

                              <v-list-item-title class="subtitle-2">
                                <span><b> &#8377;{{ dayavg ? (dayavg)?.toFixed(2) : '0.00' }}</b> <span
                                    class="caption font-weight-regular">vs</span> <b>&#8377;{{
                                      dayown_brk[dayown_brk.length
                                      -
                                      1]
                                      ?
                                      (dayown_brk[dayown_brk.length - 1])?.toFixed(2) : '0.00' }}</b></span>

                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>

                      </v-col>
                      <v-col cols="12" sm="6" class="pl-sm-1">

                        <v-card
                          v-if="archiveData.Cost ? 100 * Math.abs(archiveData.Revenue.total / archiveData.Cost.incentive_slab) > 100 : null"
                          class="rounded-lg" outlined>
                          <v-list-item two-line>
                            <v-list-item-content class="pb-1">
                              <v-list-item-subtitle>Good move
                              </v-list-item-subtitle>
                              <v-list-item-title class="subtitle-2 my-3">
                                <span><b><span>&#8377;{{ archiveData.Revenue ?
                                  Math.abs((archiveData.Revenue.balance_day_avg)?.toFixed(2)) : '0.00'
                                }}</span></b></span>

                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                        <v-card v-else class="rounded-lg" outlined>
                          <v-list-item two-line>
                            <v-list-item-content class="pb-1">
                              <v-list-item-subtitle>Yet to reach
                              </v-list-item-subtitle>
                              <v-list-item-title class="subtitle-2">
                                <span><b>&#8377;{{ archiveData.Revenue ?
                                  Math.abs(archiveData.Revenue.yet_to_reach)?.toFixed(2) : '0.00' }}</b><span
                                    class="caption font-weight-regular"> in </span><b>{{ archiveData.Revenue ?
                                      archiveData.Revenue.balance_trading_days : 0 }}</b> <span class="caption">day</span>
                                  <br> <span class="caption">{{ archiveData.Revenue ?
                                    archiveData.Revenue.balance_trading_days != 0 ?
                                      'per day' : 'balance' : '' }} &#8377;
                                    <span><b>{{ archiveData.Revenue ?
                                      Math.abs(archiveData.Revenue.balance_day_avg)?.toFixed(2)
                                      : '0.00' }}</b></span>
                                  </span></span>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-card class="rounded-lg elevation-0 mb-3 overflow-hidden" color="#EFF6FF" width="100%">
                      <v-card style="position: relative;" height="30px"
                        class="rounded-l-lg rounded-r-0 text-center elevation-0 py-1 d-flex" color="#3B82F6"
                        :width="`${archiveData.Revenue ? (100 * Math.abs(archiveData.Revenue.total / archiveData.Cost.incentive_slab)) : 0}%`">
                        <div v-if="archiveData.Revenue ? archiveData.Revenue.total != 0 : null"
                          style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
                          <span class="caption white--text">&#8377;{{ archiveData.Revenue ?
                            Math.abs((archiveData.Revenue.total)?.toFixed(2)) : '0'
                          }}</span>
                        </div>
                      </v-card>


                    </v-card> -->
                    <!-- <v-row no-glutters class="mb-0">
                      <v-col cols="6" class="pt-1 font-weight-bold caption">&#8377;{{ '0.00' }}</v-col>
                      <v-col cols="6" class="pt-1  text-right font-weight-bold caption">&#8377;{{ archiveData.Cost ?
                        (archiveData.Cost.incentive_slab)?.toFixed(2) : '0.00' }}</v-col>
                    </v-row> -->
                    <canvas :class="revloader === 'd' ? 'd-block' : 'd-none'" id="expmyChart"></canvas>
                    <v-card v-if="revloader === 'l'" color="transparent text-center" class="elevation-0" width="100%">
                      <img style="opacity: 0.1; position: relative" src="@/assets/nobarchart.png" width="100%" />
                      <span style="
                        color: #6f6f6f;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      " class="font-weight-bold">Getting revenue stat...</span>
                    </v-card>
                    <v-card v-if="revloader === 'n'" color="transparent text-center" class="elevation-0" width="100%">
                      <img style="opacity: 0.1; position: relative" src="@/assets/nobarchart.png" width="100%" />
                      <span style="
                        color: #6f6f6f;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      " class="font-weight-bold">Non-revenue data</span>
                    </v-card>

                  </v-card>
                </div>
                <!-- <div>
                  <v-progress-linear color="#3B82F6" v-if="cliloader === 'l'" indeterminate></v-progress-linear>
                  <v-card class="px-4 py-2 mb-4" outlined>

                    <p class="font-weight-bold">Active account stat</p>

                    <v-row class="mb-2">
                      <v-col cols="12" sm="6" md="12" class="pb-0">
                        <v-card class="rounded-lg" outlined>
                          <v-list-item two-line>
                            <v-list-item-content>
                              <v-list-item-subtitle class="mb-2">Opening
                                <v-chip color="#3B82F6" class="white--text " small><b>{{ clidatas.new_active_account ?
                                  clidatas.new_active_account.trading_days : 0 }}</b>&nbsp;vs&nbsp;<b>{{
    clidatas.new_active_account
    ?
    clidatas.new_active_account.Trading_days_count : 0 }}</b></v-chip>

                              </v-list-item-subtitle>
                       
                              <v-list-item-title class="subtitle-2">
                                <span><b> {{ clidatas.new_active_account ?
                                  clidatas.new_vs_traded.account_opening_target
                                  :
                                  '0' }}</b> <span class="caption font-weight-regular">vs</span> <b>{{
    clidatas.new_active_account
    ? clidatas.new_vs_traded.account_opened : '0' }} </b> accounts</span>

                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>

                      </v-col>
                      <v-col cols="12" sm="6" md="12">
                        <v-card class="rounded-lg" outlined>
                          <v-list-item two-line>
                            <v-list-item-content class="pb-1">
                              <v-list-item-subtitle>Yet to reach
                              </v-list-item-subtitle>
                              <v-list-item-title class="subtitle-2">
                                <span><b>{{ clidatas.new_active_account ?
                                  Math.abs(clidatas.new_vs_traded.account_opening_target -
                                    clidatas.new_vs_traded.account_opened) : '0' }}</b><span
                                    class="caption font-weight-regular"> in </span><b>{{ clidatas.new_active_account ?
                                      clidatas.new_active_account.balance_trading_days : 0 }}</b> <span
                                    class="caption">day</span> <br> <span class="caption">{{
                                      clidatas.new_active_account
                                      ?
                                      clidatas.new_active_account.balance_trading_days != 0 ?
                                        'per day' : 'balance' : '' }}
                                    <span> <b>{{ clidatas.new_active_account ?
                                      clidatas.new_active_account.balance_trading_days
                                        != 0 ? Math.round(clidatas.new_active_account.per_day_avg) :
                                        Math.abs(clidatas.new_vs_traded.account_opening_target -
                                          clidatas.new_vs_traded.account_opened) : '0' }}</b> accounts</span>
                                  </span></span>
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-card>
                      </v-col>
                    </v-row>
                    <canvas :class="cliloader === 'd' ? 'd-block' : 'd-none'" id="revmyChart"></canvas>
                    <v-card v-if="cliloader === 'l'" color="transparent text-center" class="elevation-0" width="100%">
                      <img style="opacity: 0.1; position: relative" src="@/assets/nobarchart.png" width="100%" />
                      <span style="
                        color: #6f6f6f;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      " class="font-weight-bold">Getting Client stat...</span>
                    </v-card>
                    <v-card v-if="cliloader === 'n'" color="transparent text-center" class="elevation-0" width="100%">
                      <img style="opacity: 0.1; position: relative" src="@/assets/nobarchart.png" width="100%" />
                      <span style="
                        color: #6f6f6f;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      " class="font-weight-bold">no Client data</span>
                    </v-card>

                  </v-card>
                </div> -->
                <!-- <div>
                  <v-progress-linear color="#3B82F6" v-if="brkaoader === 'l'" indeterminate></v-progress-linear>
                  <v-card class="px-4 py-2" outlined>
                    <p class="font-weight-bold mb-0">RM revenue stat</p>

                    <canvas :class="brkaoader === 'd' ? 'd-block' : 'd-none'" id="brkmyChart"></canvas>
                    <v-card v-if="brkaoader === 'l'" color="transparent text-center" class="elevation-0" width="100%">
                      <img style="opacity: 0.1; position: relative" src="@/assets/nobarchart.png" width="100%" />
                      <span style="
                        color: #6f6f6f;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      " class="font-weight-bold">Getting RM revenue stat...</span>
                    </v-card>
                    <v-card v-if="brkaoader === 'n'" color="transparent text-center" class="elevation-0" width="100%">
                      <img style="opacity: 0.1; position: relative" src="@/assets/nobarchart.png" width="100%" />
                      <span style="
                        color: #6f6f6f;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      " class="font-weight-bold">no RM revenue data</span>
                    </v-card>

                  </v-card>
                </div> -->
             
             <div>
              <v-card elevation="0" outlined class="py-2 pb-4 mt-8">
              <v-row no-gutters>
                      <v-col cols="12" class="mb-6">
                        <v-badge bordered overlap color="#3B82F6" :content="`${trdtotalcli}`">
                          <p class="font-weight-bold ml-4 mb-0" style="color: #6f6f6f">
                            Traded clients
                          </p>
                        </v-badge>

                        <v-skeleton-loader v-if="trdchartload" class="mx-auto mt-4" width="100%"
                          type="article"></v-skeleton-loader>
                        <canvas :class="tradechartlab.length > 0 ? 'd-block' : 'd-none'" id="trademyChart"></canvas>

                        <!-- <ChartHorizontalBar v-if="barRemeChart.datasets" :height="280" :data="barRemeChart">
                      </ChartHorizontalBar> -->
                      </v-col>
                      <v-col cols="12">
                        <v-badge bordered overlap color="#3B82F6" :content="`${newtotalcli}`">
                          <p class="font-weight-bold ml-4 mb-0" style="color: #6f6f6f">
                            New clients
                          </p>
                        </v-badge>

                        <v-skeleton-loader v-if="clichartload" class="mx-auto mt-4" width="100%"
                          type="article"></v-skeleton-loader>
                        <canvas :class="newchartlab.length > 0 ? 'd-block' : 'd-none'" id="newmyChart"></canvas>
                        <!-- <ChartHorizontalBar v-if="barRemeChart.datasets" :height="280" :data="barRemeChart">
                      </ChartHorizontalBar> -->
                      </v-col>
                    </v-row>
                  </v-card>
             </div>
             
              </v-col>
              <v-col cols="12" md="4">
                <!-- <v-col cols="12">
                    <div>
                      <v-progress-linear color="#3B82F6" v-if="cliloader === 'l'" indeterminate></v-progress-linear>
                      <v-card class="px-4 py-2" outlined>

                        <p class="font-weight-bold">Active account stat</p>

                        <v-row class="mb-2">
                          <v-col cols="12" sm="6" md="12" class="pb-0">
                            <v-card class="rounded-lg" outlined>
                              <v-list-item two-line>
                                <v-list-item-content>
                                  <v-list-item-subtitle class="mb-2">Opening
                                    <v-chip color="#3B82F6" class="white--text " small><b>{{ clidatas.new_active_account ?
                                      clidatas.new_active_account.trading_days : 0 }}</b>&nbsp;vs&nbsp;<b>{{
    clidatas.new_active_account
    ?
    clidatas.new_active_account.Trading_days_count : 0 }}</b></v-chip>

                                  </v-list-item-subtitle>
                                  <v-list-item-title class="subtitle-2">
                                    <span><b> {{ clidatas.new_active_account ?
                                      clidatas.new_vs_traded.account_opening_target
                                      :
                                      '0' }}</b> <span class="caption font-weight-regular">vs</span> <b>{{
    clidatas.new_active_account
    ? clidatas.new_vs_traded.account_opened : '0' }} </b> accounts</span>

                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>

                          </v-col>
                          <v-col cols="12" sm="6" md="12">
                            <v-card class="rounded-lg" outlined>
                              <v-list-item two-line>
                                <v-list-item-content class="pb-1">
                                  <v-list-item-subtitle>Yet to reach
                                  </v-list-item-subtitle>
                                  <v-list-item-title class="subtitle-2">
                                    <span><b>{{ clidatas.new_active_account ?
                                      Math.abs(clidatas.new_vs_traded.account_opening_target -
                                        clidatas.new_vs_traded.account_opened) : '0' }}</b><span
                                        class="caption font-weight-regular"> in </span><b>{{ clidatas.new_active_account ?
                                          clidatas.new_active_account.balance_trading_days : 0 }}</b> <span
                                        class="caption">day</span> <br> <span class="caption">{{
                                          clidatas.new_active_account
                                          ?
                                          clidatas.new_active_account.balance_trading_days != 0 ?
                                            'per day' : 'balance' : '' }}
                                        <span> <b>{{ clidatas.new_active_account ?
                                          clidatas.new_active_account.balance_trading_days
                                            != 0 ? Math.round(clidatas.new_active_account.per_day_avg) :
                                            Math.abs(clidatas.new_vs_traded.account_opening_target -
                                              clidatas.new_vs_traded.account_opened) : '0' }}</b> accounts</span>
                                      </span></span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>
                          </v-col>
                        </v-row>
                        <canvas :class="cliloader === 'd' ? 'd-block' : 'd-none'" id="revmyChart"></canvas>
                        <v-card v-if="cliloader === 'l'" color="transparent text-center" class="elevation-0" width="100%">
                          <img style="opacity: 0.1; position: relative" src="@/assets/nobarchart.png" width="100%" />
                          <span style="
                        color: #6f6f6f;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      " class="font-weight-bold">Getting Client stat...</span>
                        </v-card>
                        <v-card v-if="cliloader === 'n'" color="transparent text-center" class="elevation-0" width="100%">
                          <img style="opacity: 0.1; position: relative" src="@/assets/nobarchart.png" width="100%" />
                          <span style="
                        color: #6f6f6f;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      " class="font-weight-bold">no Client data</span>
                        </v-card>

                      </v-card>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <div>
                      <v-progress-linear color="#3B82F6" v-if="brkaoader === 'l'" indeterminate></v-progress-linear>
                      <v-card class="px-4 py-2" outlined>
                        <p class="font-weight-bold">Revenue brokerage stat</p>

                        <canvas :class="brkaoader === 'd' ? 'd-block' : 'd-none'" id="brkmyChart"></canvas>
                        <v-card v-if="brkaoader === 'l'" color="transparent text-center" class="elevation-0" width="100%">
                          <img style="opacity: 0.1; position: relative" src="@/assets/nobarchart.png" width="100%" />
                          <span style="
                        color: #6f6f6f;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      " class="font-weight-bold">Getting credit stat...</span>
                        </v-card>
                        <v-card v-if="brkaoader === 'n'" color="transparent text-center" class="elevation-0" width="100%">
                          <img style="opacity: 0.1; position: relative" src="@/assets/nobarchart.png" width="100%" />
                          <span style="
                        color: #6f6f6f;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                      " class="font-weight-bold">no credit data</span>
                        </v-card>

                      </v-card>
                    </div>
                  </v-col> -->
                <div class="mx-auto text-center mb-16 pb-12">
                  <p class="font-weight-bold mb-0 mt-6">Active / Inactive</p>
                  <v-card class="elevation-0 mx-auto" height="300px" width="100%">
                    <img v-if="!clientswise.A" src="@/assets/nodoughnutchart.png" width="100%" class="px-2" />
                    <canvas :class="clientswise.A || clientswise.I ? 'd-block' : 'd-none'
                      " class="mx-auto" id="cliAIchartid" width="100%" height="300px"></canvas>
                    <div>
                      <p class="caption font-weight-bold mb-1" style="color: #6f6f6f">
                        Total clients -
                        {{
                          clientswise.statustotal == 0 ||
                          clientswise.statustotal == null
                          ? 0
                          : clientswise.statustotal
                        }}
                      </p>
                      <p class="caption font-weight-bold mb-1" style="color: #6f6f6f">Current month Traded clients -
                        {{
                          clientswise.current_month_traders == 0 || clientswise.current_month_traders == null
                          ? 0
                          : clientswise.current_month_traders
                        }}</p>
                      <p class="caption font-weight-bold mb-1" style="color: #6f6f6f">
                        Active clients -
                        {{
                          clientswise.A == 0 || clientswise.A == null
                          ? 0
                          : clientswise.A
                        }}, Inactive clients-
                        {{
                          clientswise.I == 0 || clientswise.I == null
                          ? 0
                          : clientswise.I
                        }}
                      </p>
                    </div>
                  </v-card>
                </div>

                <div>
                  <v-card outlined class="py-2 pb-4">
                    <!-- <v-toolbar dense class="elevation-0 px-4">
                    <p class="font-weight-bold mt-5">Top 10 stat</p>
                    <v-spacer></v-spacer>
                    <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${revtblval == 'days' ? '#EFF6FF' : ''}`"
                          :disabled="renchartlab.length == 0" @click="revtableFilter((val = 'days'))" width="40px"
                          outlined class="mt-2 py-2 elevation-0 rounded-l-lg rounded-0 text-center">
                          <span :style="`color:${revtblval == 'days' ? '#3B82F6' : 'black'
                            };`" class="caption">D</span>
                        </v-card>
                      </template>
                      <span>Daily</span>
                    </v-tooltip>

                    <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${revtblval == 'weeks' ? '#EFF6FF' : ''}`"
                          :disabled="renchartlab.length == 0" @click="revtableFilter((val = 'weeks'))" width="40px"
                          outlined class="mt-2 py-2 elevation-0 rounded-0 text-center">
                          <span :style="`color:${revtblval == 'weeks' ? '#3B82F6' : 'black'
                            };`" class="caption">W</span>
                        </v-card>
                      </template>
                      <span>Weekly</span>
                    </v-tooltip>

                    <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${revtblval == 'months' ? '#EFF6FF' : ''
                          }`" :disabled="renchartlab.length == 0" @click="revtableFilter((val = 'months'))"
                          width="40px" outlined class="mt-2 py-2 elevation-0 rounded-0 text-center">
                          <span :style="`color:${revtblval == 'months' ? '#3B82F6' : 'black'
                            };`" class="caption">M</span>
                        </v-card>
                      </template>
                      <span>Monthly</span>
                    </v-tooltip>

                    <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${revtblval == 'quartly' ? '#EFF6FF' : ''
                          }`" :disabled="renchartlab.length == 0" @click="revtableFilter((val = 'quartly'))"
                          width="40px" outlined class="mt-2 py-2 elevation-0 rounded-0 text-center">
                          <span :style="`color:${revtblval == 'quartly' ? '#3B82F6' : 'black'
                            };`" class="caption">Q</span>
                        </v-card>
                      </template>
                      <span>Quarterly</span>
                    </v-tooltip>

                    <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${revtblval == 'halfly' ? '#EFF6FF' : ''}`"
                          :disabled="renchartlab.length == 0" @click="revtableFilter((val = 'halfly'))" width="40px"
                          outlined class="mt-2 py-2 elevation-0 rounded-0 text-center">
                          <span :style="`color:${revtblval == 'halfly' ? '#3B82F6' : 'black'
                            };`" class="caption">H</span>
                        </v-card>
                      </template>
                      <span>Halfly</span>
                    </v-tooltip>

                    <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${revtblval == 'years' ? '#EFF6FF' : ''}`"
                          :disabled="renchartlab.length == 0" @click="revtableFilter((val = 'years'))" width="40px"
                          outlined class="mt-2 py-2 elevation-0 rounded-r-lg rounded-0 text-center">
                          <span :style="`color:${revtblval == 'years' ? '#3B82F6' : 'black'
                            };`" class="caption">Y</span>
                        </v-card>
                      </template>
                      <span>Yearly</span>
                    </v-tooltip>
                  </v-toolbar> -->
                    <div class="px-4 mb-6">
                      <p class="font-weight-bold mt-2">Top 10 Revenue credits</p>
                      <v-card class="elevation-0 rounded-lg" height="40px" color="#EFF6FF" width="100%"
                        style="overflow: hidden">
                        <v-row v-if="showbar.length > 0" no-gutters>
                          <v-card v-for="n in showbar" :key="n.color" class="elevation-0 rounded-0" :class="n.id == 0
                            ? 'rounded-l-lg'
                            : n.id == 9
                              ? 'rounded-r-lg'
                              : ''
                            " height="40px" :color="n.color" :width="`${n.width}%`">
                            <v-tooltip color="black" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-card color="transparent" class="elevation-0" v-bind="attrs" v-on="on" height="40px"
                                  width="100%"></v-card>
                              </template>
                              <span>{{ n.CLIENT_ID }} :
                                {{ n.incentive_amt?.toFixed(2) }}</span>
                            </v-tooltip>
                          </v-card>
                        </v-row>

                        <div v-else>
                          <v-skeleton-loader v-if="noshowbar" class="mx-auto" width="100%" height="40px"
                            type="card"></v-skeleton-loader>
                          <v-card v-else color="transparent text-center" class="elevation-0 pt-6" height="40px"
                            width="100%">
                            <span style="color: #6f6f6f" class="font-weight-thin">Non-client revenue credits</span>
                          </v-card>
                        </div>
                      </v-card>
                      <v-row no-gutters class="mt-2">
                        <v-col cols="6">&#8377;
                          <span>{{
                            barminval == null ? 0 : barminval
                          }}</span></v-col>
                        <v-col class="text-right" cols="6">&#8377;
                          <span>{{
                            barmaxval == null ? 0 : barmaxval
                          }}</span></v-col>
                      </v-row>
                    </div>

                    <div class="px-4">
                      <p class="font-weight-bold mt-2">Top 10 Brokrage</p>
                      <v-card class="elevation-0 rounded-lg" height="40px" color="#EFF6FF" width="100%"
                        style="overflow: hidden">
                        <v-row v-if="brkshowbar.length > 0" no-gutters>
                          <v-card v-for="n in brkshowbar" :key="n.color" class="elevation-0 rounded-0" :class="n.id == 0
                            ? 'rounded-l-lg'
                            : n.id == 9
                              ? 'rounded-r-lg'
                              : ''
                            " height="40px" :color="n.color" :width="`${n.width}%`">
                            <v-tooltip color="black" bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-card color="transparent" class="elevation-0" v-bind="attrs" v-on="on" height="40px"
                                  width="100%"></v-card>
                              </template>
                              <span>{{ n.CLIENT_ID }} :
                                {{ n.ownbrk?.toFixed(2) }}</span>
                            </v-tooltip>
                          </v-card>
                        </v-row>

                        <div v-else>
                          <v-skeleton-loader v-if="noshowbarbrk" class="mx-auto" width="100%" height="40px"
                            type="card"></v-skeleton-loader>
                          <v-card v-else color="transparent text-center" class="elevation-0 pt-6" height="40px"
                            width="100%">
                            <span style="color: #6f6f6f" class="font-weight-thin">Non-client brokrage</span>
                          </v-card>
                        </div>
                      </v-card>
                      <v-row no-gutters class="mt-2">
                        <v-col cols="6">&#8377;
                          <span>{{
                            brkbarminval == null ? 0 : brkbarminval
                          }}</span></v-col>
                        <v-col class="text-right" cols="6">&#8377;
                          <span>{{
                            brkbarmaxval == null ? 0 : brkbarmaxval
                          }}</span></v-col>
                      </v-row>
                    </div>
                  </v-card>
                </div>

                <div>
                  <v-card elevation="0" class="py-2 pb-4 mt-4">
                    <!-- <v-toolbar dense class="elevation-0 px-4">
                      <p class="font-weight-bold mt-3 mb-0">Clients stat</p>
                      <v-spacer></v-spacer>
                       <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${clitblval == 'days' ? '#EFF6FF' : ''}`"
                          @click="clitableFilter((val = 'days'))" width="40px" outlined
                          class="mt-2 py-2 elevation-0 rounded-l-lg rounded-0 text-center">
                          <span :style="`color:${clitblval == 'days' ? '#3B82F6' : 'black'
                            };`" class="caption">D</span>
                        </v-card>
                      </template>
                      <span>Daily</span>
                    </v-tooltip>
                    <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${clitblval == 'weeks' ? '#EFF6FF' : ''}`"
                          @click="clitableFilter((val = 'weeks'))" width="40px" outlined
                          class="mt-2 py-2 elevation-0 rounded-0 text-center">
                          <span :style="`color:${clitblval == 'weeks' ? '#3B82F6' : 'black'
                            };`" class="caption">W</span>
                        </v-card>
                      </template>
                      <span>Weekly</span>
                    </v-tooltip>
                    <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${clitblval == 'months' ? '#EFF6FF' : ''
                          }`" @click="clitableFilter((val = 'months'))" width="40px" outlined
                          class="mt-2 py-2 elevation-0 rounded-0 text-center">
                          <span :style="`color:${clitblval == 'months' ? '#3B82F6' : 'black'
                            };`" class="caption">M</span>
                        </v-card>
                      </template>
                      <span>Monthly</span>
                    </v-tooltip>
                    <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${clitblval == 'quartly' ? '#EFF6FF' : ''
                          }`" @click="clitableFilter((val = 'quartly'))" width="40px" outlined
                          class="mt-2 py-2 elevation-0 rounded-0 text-center">
                          <span :style="`color:${clitblval == 'quartly' ? '#3B82F6' : 'black'
                            };`" class="caption">Q</span>
                        </v-card>
                      </template>
                      <span>Quarterly</span>
                    </v-tooltip>
                    <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${clitblval == 'halfly' ? '#EFF6FF' : ''}`"
                          @click="clitableFilter((val = 'halfly'))" width="40px" outlined
                          class="mt-2 py-2 elevation-0 rounded-0 text-center">
                          <span :style="`color:${clitblval == 'halfly' ? '#3B82F6' : 'black'
                            };`" class="caption">H</span>
                        </v-card>
                      </template>
                      <span>Halfly</span>
                    </v-tooltip>
                    <v-tooltip open-delay="400" color="black" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-card v-bind="attrs" v-on="on" :color="`${clitblval == 'years' ? '#EFF6FF' : ''}`"
                          @click="clitableFilter((val = 'years'))" width="40px" outlined
                          class="mt-2 py-2 elevation-0 rounded-r-lg rounded-0 text-center">
                          <span :style="`color:${clitblval == 'years' ? '#3B82F6' : 'black'
                            };`" class="caption">Y</span>
                        </v-card>
                      </template>
                      <span>Yearly</span>
                    </v-tooltip>
                    </v-toolbar> -->
                
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-container>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";
import { apiurl } from "../apiUrl";
import { Chart, registerables } from "chart.js";
Chart.register(...registerables);
import annotationPlugin from 'chartjs-plugin-annotation';
Chart.register(annotationPlugin);

export default {
  data() {
    return {
      datamsg: "",
      datasnackbar: false,
      totalrmcrd: [],
      funnaldata: [],
      colorbar: [
        { color: "#001141" },
        { color: "#001d6c" },
        { color: "#002d9c" },
        { color: "#0043ce" },
        { color: "#0f62fe" },
        { color: "#4589ff" },
        { color: "#78a9ff" },
        { color: "#a6c8ff" },
        { color: "#d0e2ff" },
        { color: "#edf5ff" },
      ],
      colorfun: [
        "#001141",
        "#001d6c",
        "#002d9c",
        "#0043ce",
        "#0f62fe",
        "#4589ff",
        "#78a9ff",
        "#a6c8ff",
      ],
      widthfun: ["100%", "90%", "80%", "70%", "60%", "50%", "40%", "30%"],
      fstdata: [],
      showbar: [],
      brkshowbar: [],


      newtotalcli: "0",
      trdtotalcli: "0",

      revtblval: "weeks",
      clitblval: "weeks",

      barRemeChart: {},
      renchartlab: [],

      renchartvalo: [],
      renchartvalt: [],
      renchartvalr: [],
      renchartvalf: [],
      renchartvalv: [],

      brenchartvalo: [],
      brenchartvalt: [],
      brenchartvalr: [],
      brenchartvalf: [],
      brenchartvalv: [],

      bartradeChart: {},
      tradechartlab: [],
      tradechartval: [],

      barnewChart: {},
      newchartlab: [],
      newchartval: [],

      snackbar: false,
      errMsg: "",

      clientCode: "",
      session: "",

      lineStateChart: {},
      lineOccuChart: {},
      lineQualChart: {},
      barCliChart: {},
      ledgerbarChart: {},
      acctdatas: {},

      dashboard: [],
      clientswise: {},
      brkagewise: {},

      allyears: [],
      ayfy: "",

      trdchartload: true,
      clichartload: true,
      brkaoader: true,

      barminval: null,
      barmaxval: null,
      brkbarminval: null,
      brkbarmaxval: null,

      noshowbar: true,
      noshowbarbrk: true,


      renchartload: true,
      renbrkvalue: [],
      renincvalue: [],
      rentrdvalue: [],
      // 

      date: new Date().toISOString().substr(0, 7),
      past: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substr(0, 7),

      latest: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      revloader: 'l',
      archiveData: [],
      title: [],
      own_brk: [],
      inc: [],
      emps: [],
      New_ad: [],
      Pen_New_ad: [],
      bal_New_ad: [],
      day_New_ad: [],
      dayavg: 0,
      labeldates: [],
      dayown_brk: [],

      cliloader: 'l',
      clidatas: [],
      brkamtdat: [],
    };
  },
  created() {
    this.clientCode = localStorage.getItem("brcode");
    this.session = localStorage.getItem("session");

  },
  mounted() {
    if (this.clientCode != null && this.clientCode) {
      this.getIncapiData();
      this.getArchive();
      this.getExuctive();
      this.barsetdata();
      this.getActive();
      this.getapiData();
    } else {
      this.$router.push("/");
    }

    if (this.clientCode && this.session) {
      // this.knowUserStatus();
    } else {
      // this.$router.push("/");
    }
  },
  methods: {
    getIncapiData() {
      this.emps = [];
      this.New_ad = [];
      this.Pen_New_ad = [];
      this.archiveData = [];
      this.own_brk = [];
      this.labeldates = [];
      this.dayown_brk = [];

      this.revloader = 'l';
      let adata = JSON.stringify({
        "branch_code": this.clientCode,
        "month": this.date
      });

      let aconfig = {
        method: 'post',
        url: `${apiurl}/archive_calculation`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: adata
      };

      let axiosThis = this;
      axios.request(aconfig)
        .then((response) => {
          axiosThis.archiveData = response.data;

          if (response.data.day_wise.merger_datas.length > 0) {
            let revenuedaydata = [];
            revenuedaydata = response.data.day_wise.merger_datas;

            for (let q = 0; q < revenuedaydata.length; q++) {
              axiosThis.own_brk.push(revenuedaydata[q].All_brk);
              axiosThis.labeldates.push(revenuedaydata[q].TRADE_DATE)
            }
            axiosThis.dayavg = response.data.Cost.per_day_avg;

            let dayown_brk = [];
            dayown_brk = axiosThis.own_brk.map((s => a => s += a)(0));
            for (let l = 0; l < dayown_brk.length; l++) {
              if (l < response.data.day_wise.brk_data_dates.length) {
                axiosThis.dayown_brk.push(dayown_brk[l] / (l + 1))
              }
            }
            axiosThis.setIncentiveStat();
          } else {
            axiosThis.revloader = 'n';
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getArchive() {
      this.renchartlab = [];
      this.renbrkvalue = [];
      this.renincvalue = [];
      this.rentrdvalue - [];
      this.clidatas = [];

      this.cliloader = 'l';
      let adata = JSON.stringify({
        "branch_code": this.clientCode,
        "Month": this.date,
      });

      let aconfig = {
        method: 'post',
        url: `${apiurl}/archive_calculation1`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: adata
      };

      let axiosThis = this;
      axios.request(aconfig)
        .then((response) => {
          if (response.data.new_active_account) {
            let clidata = response.data.new_active_account.account_opened.accounts;
            for (let e = 0; e < clidata.length; e++) {
              axiosThis.renchartlab.push(clidata[e].Employee_code);
              axiosThis.renbrkvalue.push(clidata[e].tot_ad);
              axiosThis.renincvalue.push(clidata[e].completed_ad);
              axiosThis.rentrdvalue.push(clidata[e].Traded);
            }
            axiosThis.renchartlab.push('Direct');
            axiosThis.renbrkvalue.push(0);
            axiosThis.renincvalue.push(response.data.new_active_account.account_opened.direct)
            axiosThis.rentrdvalue.push(response.data.new_active_account.account_opened.direct_accounts_traded)
            axiosThis.clidatas = response.data;
            axiosThis.setRevenueStat();
          } else {
            axiosThis.cliloader = 'n';
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getExuctive() {
      this.brkaoader = 'l';
      this.brkamtdat = [];
      let data = JSON.stringify({
        "branch_code": this.clientCode,
        "Month": this.date,
      });

      let config = {
        method: 'post',
        url: `${apiurl}/brk_amt_recived`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };

      let axiosThis = this;
      axios.request(config)
        .then((response) => {
          if (response.data.length > 0) {
            axiosThis.brkamtdat['lable'] = [];
            axiosThis.brkamtdat['exp'] = [];
            axiosThis.brkamtdat['arc'] = [];
            axiosThis.brkamtdat['ctc'] = [];
            for (let b = 0; b < response.data.length; b++) {
              axiosThis.brkamtdat.lable.push(response.data[b].Employee_code)
              axiosThis.brkamtdat.exp.push(response.data[b].expected_brk)
              axiosThis.brkamtdat.arc.push(response.data[b].archived_brk)
              axiosThis.brkamtdat.ctc.push(response.data[b].Monthly_CTC)
            }
            axiosThis.setBrkamtStat();
          } else {
            axiosThis.brkaoader = 'n';

          }
        })
        .catch((error) => {
          console.log(error);
        });

    },
    setIncentiveStat() {
      let renmin = Math.min(...this.own_brk)
      if (renmin >= 1000) {
        renmin = 1000 * Math.round((renmin / 1.2) / 1000);
      } else {
        renmin = 100 * Math.round((renmin / 1.5) / 100);
      }

      this.revloader = 'd';
      const expchart = document.getElementById("expmyChart").getContext("2d");
      this.expchart = new Chart(expchart, {
        type: "line",
        data: {
          labels: this.labeldates,
          datasets: [

            {
              label: 'Average brokrage',
              data: this.dayown_brk,
              backgroundColor: '#3B82F6',
              borderColor: '#3B82F6',
              type: 'line',
              pointRadius: 1,
              borderWidth: 1,
            },
            {
              label: 'Brokrage',
              data: this.own_brk,
              backgroundColor: '#3B82F630',
              borderRadius: 4,
              type: 'bar',
            },
            // {
            //   label: 'Day average brokrage',
            //   data: this.dayavg,
            //   backgroundColor: 'orange',
            //   borderColor: 'orange',
            //   type: 'line',
            //   borderWidth: 1,
            //   pointRadius: 0,
            //   borderStyle: 'dash'
            // },
          ],
        },
        options: {
          layout: {
            padding: {
              top: 15,
              right: 5,
              left: 5,
              bottom: 10,
            },
          },
          // responsive: true,
          // maintainAspectRatio: false,
          plugins: {
            annotation: {
              annotations: {
                box1: {
                  type: 'line',
                  scaleID: 'y',
                  value: this.dayavg,
                  borderWidth: 1,
                  borderColor: 'orange'
                }
              }
            },
            legend: {
              display: false,
            },
          },
          tooltips: {
            enabled: true,
            mode: "index",
            intersect: false,
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
              ticks: {
                suggestedMin: 0,
                suggestedMax: 1000,
                display: true,
                color: "#000000",
                font: {
                  size: 10,
                  lineHeight: 1.8,
                  weight: "400",
                  family: "Inter",
                },
              },
            },
            y: {
              min: renmin,
              grid: {
                display: false,
              },
              ticks: {
                suggestedMin: 0,
                suggestedMax: 1000,
                display: true,
                color: "#000000",
                font: {
                  size: 12,
                  lineHeight: 1.8,
                  weight: "600",
                  family: "Inter",
                },
              },
            },
            // x: {
            //   stacked: true,
            //   grid: {
            //     display: false,
            //   },
            //   ticks: {
            //     display: true,
            //   },
            // },
          },
        },
      });
    },
    monthChange() {
      this.$refs.menu.save(this.date);
      this.getIncapiData();
      this.getArchive();
      this.getExuctive();
      this.getapiData();
      this.barsetdata();
      this.tradechart.destroy();
      this.newchart.destroy();
      this.showbar = [];
      this.brkshowbar = [];

      // this.incchart.destroy();
      this.expchart.destroy();
      // this.brkachart.destroy();

      this.barminval = null;
      this.barmaxval = null;
      this.noshowbar = true;
      this.brkbarminval = null;
      this.brkbarmaxval = null;
      this.noshowbarbrk = true;

 
      this.clichartload = true;
      this.trdchartload = true;
      this.trdtotalcli = "0";
      this.newtotalcli = "0";
    },
    setAIchart() {
      const cliAIchart = document.getElementById("cliAIchartid").getContext("2d");
      this.AIchart = new Chart(cliAIchart, {
        type: "doughnut",
        data: {
          labels: ["Current month Traded clients", "Active clients", "Inactive clients"],
          datasets: [
            {
              label: " clients",
              data: [this.clientswise.current_month_traders, this.clientswise.A, this.clientswise.I],
              backgroundColor: [
                "#3B82F6",
                "#a6c8ff",
                "#EFF6FF",
                // '#2ECE14',
                // '#00B2FE'
              ],
              borderWidth: 0,
              radius: "80%",
            },
          ],
        },
        options: {
          cutout: "60%",
          title: {
            display: false,
          },
          plugins: {
            legend: {
              display: false,
            },
            title: {
              display: false,
            },
          },
        },
      });
    },

    getActive() {
      let data = JSON.stringify({
        "branch_code": this.clientCode,
      });

      let config = {
        method: 'post',
        url: `${apiurl}/active_and_inactive`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      let axiosThis = this;
      axios.request(config)
        .then((response) => {
          if (response.data) {
            axiosThis.clientswise = response.data;
            axiosThis.clientswise["statustotal"] = (response.data.Alldata.A + response.data.Alldata.I);
            axiosThis.clientswise["A"] = response.data.Alldata.A;
            axiosThis.clientswise["I"] = response.data.Alldata.I;
            axiosThis.setAIchart();
          }
        })
        .catch((error) => {
          console.log(error);
        });

    },
    setRevenueStat() {
      // let renmin = Math.Max(...this.renbrkvalue)
      // renmin = (renmin * 2);
      this.cliloader = 'd';
      const incchart = document.getElementById("revmyChart").getContext("2d");
      this.incchart = new Chart(incchart, {
        type: "bar",
        data: {
          labels: this.renchartlab,
          datasets: [
            {
              label: 'Total Accounts Opening',
              data: this.renbrkvalue,
              backgroundColor: '#3B82F6',
              borderRadius: 4,
            },
            {
              label: 'Accounts Opened',
              data: this.renincvalue,
              backgroundColor: '#a6c8ff',
              borderRadius: 4,

            },
            {
              label: 'Traded Accounts',
              data: this.rentrdvalue,
              backgroundColor: '#EFF6FF',
              borderRadius: 4,

            },
          ],
        },
        options: {
          layout: {
            padding: {
              top: 15,
              right: 5,
              left: 5,
              bottom: 10,
            },
          },
          // responsive: true,
          // maintainAspectRatio: false,
          plugins: {
            // annotation: {
            //   annotations: {
            //     box1: {
            //       type: 'line',
            //       scaleID: 'y',
            //       value: renmin,
            //       borderWidth: 1,
            //       borderColor: 'orange'
            //     }
            //   }
            // },
            legend: {
              display: false,
            },
          },
          tooltips: {
            enabled: true,
            mode: "index",
            intersect: false,
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
              ticks: {
                suggestedMin: 0,
                suggestedMax: 1000,
                display: true,
                color: "#000000",
                font: {
                  size: 9,
                  lineHeight: 0.8,
                  weight: "400",
                  family: "Inter",
                },
              },
            },
            y: {
              // max: renmin,
              grid: {
                display: false,
              },
              ticks: {
                suggestedMin: 0,
                suggestedMax: 1000,
                display: true,
                color: "#000000",
                font: {
                  size: 12,
                  lineHeight: 1.8,
                  weight: "600",
                  family: "Inter",
                },
              },
            },
            // x: {
            //   stacked: true,
            //   grid: {
            //     display: false,
            //   },
            //   ticks: {
            //     display: true,
            //   },
            // },
          },
        },
      });
    },
    setBrkamtStat() {
      this.brkaoader = 'd';
      const brkachart = document.getElementById("brkmyChart").getContext("2d");
      this.brkachart = new Chart(brkachart, {
        type: "bar",
        data: {
          labels: this.brkamtdat.lable,
          datasets: [
            // {
            //   label: 'CTC',
            //   data: this.brkamtdat.ctc,
            //   backgroundColor: '#3B82F6',
            //   borderRadius: 4,
            // },
            {
              label: 'Brokerage',
              data: this.brkamtdat.exp,
              backgroundColor: '#3B82F6',
              borderRadius: 4,

            },
            {
              label: 'Revenue credit',
              data: this.brkamtdat.arc,
              backgroundColor: '#a6c8ff',
              borderRadius: 4,
            },
          ],
        },
        options: {
          indexAxis: "y",
          layout: {
            padding: {
              top: 15,
              right: 5,
              left: 5,
              bottom: 10,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
          tooltips: {
            enabled: true,
            mode: "index",
            intersect: false,
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
              ticks: {
                suggestedMin: 0,
                suggestedMax: 1000,
                display: true,
                color: "#000000",
                font: {
                  size: 9,
                  lineHeight: 0.8,
                  weight: "400",
                  family: "Inter",
                },
              },
            },
            y: {
              // max: renmin,
              grid: {
                display: false,
              },
              ticks: {
                suggestedMin: 0,
                suggestedMax: 1000,
                display: true,
                color: "#000000",
                font: {
                  size: 12,
                  lineHeight: 1.8,
                  weight: "600",
                  family: "Inter",
                },
              },
            },
          },
        },
      });
    },
    revUpdate() {
      this.getRevapiData();
      this.renchart.destroy();
      this.renchartload = true;
      this.renchartlab = [];
      this.renincvalue = [];
      this.rentrdvalue = [];
      this.renbrkvalue = [];
    },
    revtableFilter(val) {
      if (val != this.revtblval) {
        this.revtblval = val;
        // this.revUpdate();
        this.showbar = [];
        this.barminval = null;
        this.barmaxval = null;
        this.noshowbar = true;
        this.brkshowbar = [];
        this.brkbarminval = null;
        this.brkbarmaxval = null;
        this.noshowbarbrk = true;
        this.barsetdata();
      }
    },
    barsetdata() {
      let data = JSON.stringify({
        "branch_code": this.clientCode,
        "month": this.date
      });

      let config = {
        method: 'post',
        url: `${apiurl}/dash_board_top_ten_performer`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
      };
      let axiosThis = this;
      axios.request(config)
        .then((response) => {
          axiosThis.totalrmcrd = response.data.incentive;
          axiosThis.totalbrkcli = response.data.brk;

          if (axiosThis.totalrmcrd.length > 0) {
            let sortval = axiosThis.totalrmcrd.sort(
              (a, b) => parseFloat(a.incentive_amt) - parseFloat(b.incentive_amt)
            );
            let totals = sortval.reduce((acc, o) => acc + parseInt(o.incentive_amt), 0);
            let calctol = [];
            for (let w = 0; w < sortval.length; w++) {
              sortval[w]["width"] = null;
              sortval[w]["color"] = null;
              sortval[w]["id"] = null;
              sortval[w].width = ((sortval[w].incentive_amt - totals) / totals) * 100 + 100;
              sortval[w].color = axiosThis.colorbar[w].color;
              sortval[w].id = w;
              calctol.push(sortval[w].width);
            }
            let sumof = calctol.reduce((a, b) => a + b, 0);
            if (sumof == 100) {
              axiosThis.showbar = sortval;
            } else {
              if (sumof > 0) {
                sortval[sortval.length - 1].width = sortval[sortval.length - 1].width - (sumof - 100);
              } else {
                //
              }
              axiosThis.showbar = sortval;
            }

            axiosThis.barminval = axiosThis.showbar[0].incentive_amt?.toFixed(2);
            axiosThis.barmaxval = axiosThis.showbar[axiosThis.showbar.length - 1].incentive_amt?.toFixed(2);

            // console.log("sortval", this.showbar, totals);
          } else {
            this.barminval = 0;
            this.barmaxval = 0;
            this.noshowbar = false;
          }
          if (axiosThis.totalbrkcli.length > 0) {
            let sortval = axiosThis.totalbrkcli.sort(
              (a, b) => parseFloat(a.ownbrk) - parseFloat(b.ownbrk)
            );
            let totals = sortval.reduce((acc, o) => acc + parseInt(o.ownbrk), 0);
            let calctol = [];
            for (let w = 0; w < sortval.length; w++) {
              sortval[w]["width"] = null;
              sortval[w]["color"] = null;
              sortval[w]["id"] = null;
              sortval[w].width = ((sortval[w].ownbrk - totals) / totals) * 100 + 100;
              sortval[w].color = axiosThis.colorbar[w].color;
              sortval[w].id = w;
              calctol.push(sortval[w].width);
            }
            let sumof = calctol.reduce((a, b) => a + b, 0);
            if (sumof == 100) {
              axiosThis.brkshowbar = sortval;
            } else {
              if (sumof > 0) {
                sortval[sortval.length - 1].width = sortval[sortval.length - 1].width - (sumof - 100);
              } else {
                //
              }
              axiosThis.brkshowbar = sortval;
            }

            axiosThis.brkbarminval = axiosThis.brkshowbar[0].ownbrk?.toFixed(2);
            axiosThis.brkbarmaxval = axiosThis.brkshowbar[axiosThis.brkshowbar.length - 1].ownbrk?.toFixed(2);

            // console.log("sortval", this.showbar, totals);
          } else {
            this.brkbarminval = 0;
            this.brkbarmaxval = 0;
            this.noshowbarbrk = false;
          }
        })
        .catch((error) => {
          console.log(error);
        });


    },
    // ----- >

    // clients stat < -----


    getapiData() {
      let trddataget = [];
      let data = JSON.stringify({
        "branch_code": this.clientCode,
        // "values": this.clitblval
        "month": this.date

      });
      let tadconfig = {
        method: "post",
        url: `${apiurl}/trade_stat`,

        headers: {
          // Authorization: this.session,
          "Content-Type": "application/json",
        },
        data: data
      };

      let axiosThis = this;
      axios
        .request(tadconfig)
        .then((response) => {
          if (response.data) {
            trddataget = response.data;
            let revdata = trddataget.sort((a, b) => parseFloat(a.id) - parseFloat(b.id));
            axiosThis.tradechartval = [];
            axiosThis.tradechartlab = [];
            if (trddataget) {
              for (let a = 0; a < revdata.length; a++) {
                axiosThis.tradechartval.push(revdata[a].value);
                axiosThis.tradechartlab.push(revdata[a].date);
              }

              // for (const [key, value] of Object.entries(trddataget)) {
              //   axiosThis.tradechartval.push(value);
              //   axiosThis.tradechartlab.push(key);
              // }
              axiosThis.trdchartload = false;
              axiosThis.setTrdstat();

              axiosThis.trdtotalcli = Math.max(...axiosThis.tradechartval);
            } else {
              axiosThis.trdtotalcli = "0";
            }
          }
          // console.log(
          //   "newclients",
          //   clidataget,
          //   axiosThis.tradechartlab,
          //   axiosThis.tradechartval
          // );
        })
        .catch((error) => {
          console.log(error);
        });

      let clidataget = [];
      let config = {
        method: "post",
        url: `${apiurl}/new_client_stat`,

        headers: {
          "Content-Type": "application/json",
        },
        data: data

      };

      axios
        .request(config)
        .then((response) => {
          clidataget = response.data;
          let revdata = clidataget.sort((a, b) => parseFloat(a.id) - parseFloat(b.id));

          axiosThis.newchartval = [];
          axiosThis.newchartlab = [];
          if (clidataget) {
            for (let a = 0; a < revdata.length; a++) {
              axiosThis.newchartval.push(revdata[a].value);
              axiosThis.newchartlab.push(revdata[a].date);
            }
            // for (const [key, value] of Object.entries(clidataget)) {
            //   axiosThis.newchartval.push(value);
            //   axiosThis.newchartlab.push(key);
            // }
            axiosThis.clichartload = false;
            axiosThis.setNewStat();
            axiosThis.newtotalcli = axiosThis.newchartval.reduce(
              (a, b) => a + b
            );
          } else {
            axiosThis.newtotalcli = "0";
          }
          // console.log(
          //   "newclients",
          //   clidataget,
          //   axiosThis.newchartlab,
          //   axiosThis.newchartval
          // );
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setNewStat() {
      if (this.newchartlab) {
        const pdtchart = document.getElementById("newmyChart").getContext("2d");
        this.newchart = new Chart(pdtchart, {
          type: "bar",
          data: {
            labels: this.newchartlab,
            datasets: [
              {
                label: " Clients",
                fill: true,
                tension: 0.4,
                pointRadius: 3,
                borderWidth: 0,
                borderRadius: 4,
                borderColor: "#3B82F6",
                backgroundColor: "#cee0fd",
                data: this.newchartval,
                pointBackgroundColor: "#ffffff",
                pointBorderColor: "#ffffff",
              },
            ],
          },
          options: {
            indexAxis: "y",
            layout: {
              padding: {
                top: 0,
                right: 16,
                left: 8,
                bottom: 0,
              },
            },
            // responsive: true,
            // maintainAspectRatio: false,
            plugins: {
              legend: {
                display: false,
              },
            },
            tooltips: {
              enabled: true,
              mode: "index",
              intersect: false,
            },
            scales: {
              y: {
                grid: {
                  display: true,
                  color: "rgba(0, 0, 0, .2)",
                  zeroLineColor: "#000000",
                  borderDash: [6],
                  borderDashOffset: [6],
                },
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 1000,
                  display: true,
                  color: "#000000",
                  font: {
                    size: 12,
                    lineHeight: 1.8,
                    weight: "600",
                    family: "Inter",
                  },
                },
              },
              x: {
                grid: {
                  display: false,
                },
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 1000,
                  display: true,
                  color: "#000000",
                  font: {
                    size: 10,
                    lineHeight: 1.8,
                    weight: "400",
                    family: "Inter",
                  },
                },
              },
            },
          },
        });
      }
    },
    setTrdstat() {
      if (this.tradechartlab) {
        const pdochart = document
          .getElementById("trademyChart")
          .getContext("2d");
        this.tradechart = new Chart(pdochart, {
          type: "bar",
          data: {
            labels: this.tradechartlab,
            datasets: [
              {
                label: " values",
                fill: true,
                tension: 0.4,
                pointRadius: 3,
                borderWidth: 0,
                borderRadius: 4,
                borderColor: "#3B82F6",
                backgroundColor: "#cee0fd",
                data: this.tradechartval,
                pointBackgroundColor: "#ffffff",
                pointBorderColor: "#ffffff",
              },
            ],
          },
          options: {
            indexAxis: "y",
            layout: {
              padding: {
                top: 0,
                right: 16,
                left: 8,
                bottom: 0,
              },
            },
            // // responsive: true,
            // // maintainAspectRatio: true,
            plugins: {
              legend: {
                display: false,
              },
            },
            tooltips: {
              enabled: true,
              mode: "index",
              intersect: false,
            },
            scales: {
              y: {
                grid: {
                  display: true,
                  color: "rgba(0, 0, 0, .2)",
                  zeroLineColor: "#000000",
                  borderDash: [6],
                  borderDashOffset: [6],
                },
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 1000,
                  display: true,
                  color: "#000000",
                  font: {
                    size: 12,
                    lineHeight: 1.8,
                    weight: "600",
                    family: "Inter",
                  },
                },
              },
              x: {
                grid: {
                  display: false,
                },
                ticks: {
                  suggestedMin: 0,
                  suggestedMax: 1000,
                  display: true,
                  color: "#000000",
                  font: {
                    size: 10,
                    lineHeight: 1.8,
                    weight: "400",
                    family: "Inter",
                  },
                },
              },
            },
          },
        });
      }
    },
    cliUpdate() {
      this.getapiData();
      this.tradechart.destroy();
      this.newchart.destroy();
      this.clichartload = true;
      this.trdchartload = true;
      this.trdtotalcli = "0";
      this.newtotalcli = "0";
    },
    clitableFilter(val) {
      if (val != this.clitblval) {
        this.clitblval = val;
        this.cliUpdate();
      }
    },
  },
  components: {
    // ChartLinetc,
    // ChartBartc,
    // ChartHorizontalBar,
  },

  computed: {
    headers() {
      return [
        { text: "Client ID", value: "Client_ID" },
        { text: "EQ", value: "NSE_CASH", align: "right" },
        { text: "FNO", value: "NSE_FNO", align: "right" },
        { text: "CDS", value: "CD_NSE", align: "right" },
        { text: "MCX", value: "MCX", align: "right" },
        { text: "TOTAL", value: "total", align: "right" },
      ];
    },
  },
};
</script>

<style>
.chartmdl {
  position: relative;
  text-align: center;
}

.chartctn {
  display: none;
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.bartxtsty {
  font-size: 10px;
}

.dash-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}

.dash-header__titles {
  flex: 1 1 220px;
  min-width: 0;
}

.dash-header__title {
  line-height: 1.2;
}

.dash-header__subtitle {
  color: #878B93;
  font-size: 0.95rem;
  line-height: 1.4;
  word-break: break-word;
}

@media (max-width: 599px) {
  .dash-header__subtitle {
    font-size: 0.85rem;
  }
}

.dash-header__picker {
  max-width: 180px;
  flex-shrink: 0;
}

@media (max-width: 599px) {
  .dash-header {
    flex-direction: column;
    align-items: stretch;
  }

  .dash-header__titles {
    flex: 0 0 auto;
  }

  .dash-header__title {
    font-size: 1.5rem !important;
  }

  .dash-header__picker {
    max-width: 100%;
  }
}
</style>
